module.exports = __webpack_public_path__ + "img/2.9b9af48e.webp";